export default {
  'cfdSettings.title': '客显屏设置',
  'cfdSettings.onlyDisplayBillTotal': '支付时仅显示总计金额',
  'cfdSettings.updateSuccess': '更新设置成功',
};
